
import {ads_config} from "./config"
import {cacheData, checkCache} from "./storage";
import {displayError} from "./dom-manipulation";
import urls from "../../common/js/urls";

export const ADS_CACHE_INVALIDATION_KEY = 'adsAccountCacheInvalidation';
const ADS_CACHE_SCHEMA_VERSION = 'origin-v2';

const normalizeAccountIds = (accountIds) => (
    Array.from(new Set(
        (Array.isArray(accountIds) ? accountIds : [accountIds])
            .map((accountId) => String(accountId || '').trim())
            .filter(Boolean)
    ))
);

const getBrowserStorage = (storageName) => {
    try {
        return window[storageName];
    } catch (error) {
        return null;
    }
};

const safeStorageGetItem = (storageName, key) => {
    const storage = getBrowserStorage(storageName);
    if (!storage) {
        return null;
    }
    try {
        return storage.getItem(key);
    } catch (error) {
        return null;
    }
};

const safeStorageSetItem = (storageName, key, value) => {
    const storage = getBrowserStorage(storageName);
    if (!storage) {
        return;
    }
    try {
        storage.setItem(key, value);
    } catch (error) {
        // Cache invalidation is best-effort and must not change an accepted operation result.
    }
};

const safeStorageRemoveItem = (storageName, key) => {
    const storage = getBrowserStorage(storageName);
    if (!storage) {
        return;
    }
    try {
        storage.removeItem(key);
    } catch (error) {
        // Cache invalidation is best-effort and must not change an accepted operation result.
    }
};

const readQueuedAccountIds = () => {
    try {
        return normalizeAccountIds(JSON.parse(safeStorageGetItem('sessionStorage', ADS_CACHE_INVALIDATION_KEY) || '[]'));
    } catch (error) {
        safeStorageRemoveItem('sessionStorage', ADS_CACHE_INVALIDATION_KEY);
        return [];
    }
};

const getAccountAdsCacheKey = (accountId, url = urls.getAds) => `${url}${accountId}:${ADS_CACHE_SCHEMA_VERSION}`;
const getLegacyAccountAdsCacheKey = (accountId, url = urls.getAds) => `${url}${accountId}`;

const isBumpOriginDebugEnabled = () => safeStorageGetItem('localStorage', 'debugBumpOrigin') === '1';

export function invalidateAccountAdsCache(accountIds = []) {
    normalizeAccountIds(accountIds).forEach((accountId) => {
        safeStorageRemoveItem('localStorage', getAccountAdsCacheKey(accountId));
        safeStorageRemoveItem('localStorage', getLegacyAccountAdsCacheKey(accountId));
    });
}

export function queueAccountAdsCacheInvalidation(accountIds = []) {
    const ids = normalizeAccountIds(accountIds);
    if (!ids.length) {
        return;
    }
    invalidateAccountAdsCache(ids);
    const existingIds = readQueuedAccountIds();
    safeStorageSetItem(
        'sessionStorage',
        ADS_CACHE_INVALIDATION_KEY,
        JSON.stringify(normalizeAccountIds([...existingIds, ...ids])),
    );
}

export function consumeQueuedAccountAdsCacheInvalidation() {
    const ids = readQueuedAccountIds();
    if (!ids.length) {
        return [];
    }
    invalidateAccountAdsCache(ids);
    safeStorageRemoveItem('sessionStorage', ADS_CACHE_INVALIDATION_KEY);
    return ids;
}

export async function getAds(account) {
    console.log('getAds 1')
    let res = await fetchAccountAds(urls.getAds, account.account_id);
    console.log('getAds', res)
    const ads = res.hasOwnProperty('data') ? res.data : res;
    return {account, ads: ads};
};

export async function getRareData(property) {
    let data = await fetchRareData(ads_config.rareData[property]['url']);
    //console.log('getRareData(property) data', data)
    ads_config.rareData[property]['data'] = data
};


export async function processRareData() {
    for (const prop in ads_config.rareData) {
        await getRareData(prop);
    }
    ;

};


export async function getBotsAndConnections() {
    const simpleBotsResponse = await getSimpleBots();
    ads_config.all_bots = simpleBotsResponse.bots;

    const connectionsResponse = await getConnections();
    ads_config.all_connections = connectionsResponse.connections;

    return;
}

export async function getAccounts() {
    return $.ajax({
        url: urls.accounts,
        method: 'get',

        // если успешно, то
        success: function (response) {
            console.log('getAccounts', response)
            return response

        },
        // если ошибка, то
        error: function (response) {
            // предупредим об ошибке
            displayError('Error in fetching of accounts')
            console.log(response)
        }
    });
};

//getAccounts();

export async function fetchAccountAds(url, account_id) {
    const csrftoken = getCookie('csrftoken');
    const ttl = 60;
    const cacheKey = getAccountAdsCacheKey(account_id, url);
    const debugBumpOrigin = isBumpOriginDebugEnabled();
    const cachedData = debugBumpOrigin ? null : checkCache(cacheKey, ttl);
    if (cachedData !== null) {
        return Promise.resolve(cachedData);
    }
    console.log('fetchAccountAds url', url)
    return $.ajax({
        url: url,
        method: 'post',
        headers: {
            'X-CSRFToken': csrftoken,
        },
        data: {
            account_id: account_id,
            debug_bump_origin: debugBumpOrigin ? '1' : '',
        },

        // если успешно, то
        success: function (response) {
            cacheData(cacheKey, response);
            return response

        },
        // если ошибка, то
        error: function (response) {
            // предупредим об ошибке
            console.log(response)
        }
    });
}

export async function getBots() {
    return $.ajax({
        url: urls.bot,
        method: 'get',

        // если успешно, то
        success: function (response) {
            return response

        },
        // если ошибка, то
        error: function (response) {
            // предупредим об ошибке
            displayError('Error in getting of bots')
            console.log(response)
        }
    });
}

export async function getConnections() {
    return $.ajax({
        url: urls.connections,
        method: 'get',

        // если успешно, то
        success: function (response) {
            return response

        },
        // если ошибка, то
        error: function (response) {
            // предупредим об ошибке
            displayError('Error in getting of connections')
            console.log(response)
        }
    });
}


export async function getSimpleBots() {
    return $.ajax({
        url: urls.botSimple,
        method: 'get',

        // если успешно, то
        success: function (response) {
            return response

        },
        // если ошибка, то
        error: function (response) {
            // предупредим об ошибке
            displayError('Error in getting of simple bots info')
            console.log(response)
        }
    });
}


export async function fetchRareData(url, ttl = 7200) {
    const cacheKey = `${url}`
    const cachedData = checkCache(cacheKey, ttl);
    if (cachedData !== null) {return Promise.resolve(cachedData);}

    return $.ajax({
        url: url,
        method: 'get',

        // если успешно, то
        success: function (response) {
            console.log('fetchRareData', response)
            cacheData(cacheKey, response);
            return response
        },
        // если ошибка, то
        error: function (response) {
            // предупредим об ошибке
            displayError('Error in fetching of rare data')
            console.log(response)
        }
    });

}

export function getCookie(name) {
    const cookieValue = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return cookieValue ? cookieValue.pop() : '';
}

export async function getCitiesFromDjango(cityIdsToUpdate) {
    const csrftoken = getCookie('csrftoken');
    let ids = {ids: cityIdsToUpdate};

    return $.ajax({
        url: urls.cities,
        method: 'POST',
        headers: {
            'X-CSRFToken': csrftoken,
        },
        data: JSON.stringify(ids),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
    }).then(data => {
        console.log('getCitiesFromDjango success data', data);
        const cities = data.data || []; // default to empty array if data.data is undefined
        console.log('getCitiesFromDjango success cities', cities);
        return cities;
    }).catch(error => {
        console.log('Error on getting cities from django', error);
        return []; // return an empty array in case of error
    });
}


export async function getBillingData() {
    return $.ajax({
        url: urls.getUserBilling,
        method: 'get',

        // если успешно, то
        success: function (response) {
            return response

        },
        // если ошибка, то
        error: function (response) {
            // предупредим об ошибке
            displayError('Error in getting billing data')
            console.log(response)
        }
    });
}

export async function getUserCards() {
    return $.ajax({
        url: urls.getUserCards,
        method: 'get',

        // если успешно, то
        success: function (response) {
            return response

        },
        // если ошибка, то
        error: function (response) {
            // предупредим об ошибке
            displayError('Error in getting user cards')
            console.log(response)
        }
    });
}
